export const lookupHeadingTextForCode = (fields:any[], code) => {
    return fields.find((field) => field.name === code)?.label ?? '';
}